(function() {
  'use strict';
  angular.module('app.discovererProgress', []);
})();
